import { JiraRoleDetail, RoleSelectOption } from '../types/SpaceInputTypes';

export const getRoleAsOption = (role: JiraRoleDetail): RoleSelectOption => ({
	value: `${role.id}`,
	label: role.name,
	role,
});

export const getDefaultRole = (roles: JiraRoleDetail[]): JiraRoleDetail | undefined => {
	const defaultRoles = roles.filter(({ default: roleDefault }) => roleDefault);
	return defaultRoles[0] || roles[0];
};
